export const componentWithCondition = Component => {
  return function ({ lhs, rhs, ...props }) {
    if (lhs === rhs) return <Component {...props} />;
    return null;
  };
};
